import showModal from '@/utils/show_modal';
import makeVueModal from '@/views/modal/make_vue_modal';
import { isMobile } from '@/helpers/mobile_detect';

let profileMenuModal = null;
let contactsModal = null;
let localeSwitcherModal = null;
let authModal = null;

$(document).on('turbolinks:before-cache', () => {
  if (profileMenuModal) {
    profileMenuModal.hide();
    profileMenuModal.destroy();
    profileMenuModal = null;
  }

  if (contactsModal) {
    contactsModal.destroy();
    contactsModal = null;
  }

  if (localeSwitcherModal) {
    localeSwitcherModal.destroy();
    localeSwitcherModal = null;
  }

  if (authModal) {
    authModal.destroy();
    authModal = null;
  }
});

$(document).on('turbolinks:load', () => {
  if (!document.body.className.includes('v4')) { return; }

  $('.b-top_menu .profile').on('click', e => {
    if (!isMobile()) {
      return;
    }

    e.preventDefault();
    profileMenuModal ||= showModal({
      $modal: $('.b-top_menu .popup'),
      $trigger: $('.b-top_menu .profile'),
      show() {
        $('.b-top_menu .popup').addClass('is-active');
      },
      hide() {
        $('.b-top_menu .popup').removeClass('is-active');
      },
      isHiddenCheck() {
        return !$('.b-top_menu .popup').hasClass('is-active');
      }
    })
      .show();

    $('.b-top_menu .close').on('click', profileMenuModal.hide);
  });

  $('.b-top_menu .contacts-modal-trigger').one('click', async ({ currentTarget }) => {
    const $node = $(currentTarget);

    contactsModal ||= makeVueModal({
      trigger: currentTarget,
      vue: {
        importComponent: async () => await import('@/vue/modals/contacts'),
        props: {
          submitUrl: $node.data('submit_url'),
          leadType: $node.data('lead-type'),
          trackEvent: $node.data('track-event'),
          trackEventLocation: $node.data('track-event-location'),
          privacyUrl: $node.data('privacy_url'),
          phoneUrl: $node.data('phone_url'),
          lineUrl: $node.data('line_url'),
          whatsappUrl: $node.data('whatsapp_url'),
          telegramUrl: $node.data('telegram_url'),
          maxUrl: $node.data('whatsapp_url'),
          faqUrl: $node.data('faq_url'),
          graphqlUrl: $node.data('graphql_url')
        }
      }
    });
    contactsModal.show();
  });

  $('.b-top_menu .locale_switcher-modal-trigger').one('click', async ({ currentTarget }) => {
    localeSwitcherModal ||= makeVueModal({
      trigger: currentTarget,
      vue: {
        importComponent: async () => await import('@/vue/modals/locale_switcher')
      }
    });
    localeSwitcherModal.show();
  });

  $('.b-top_menu .auth').on('click', async e => {
    e.preventDefault();

    const $trigger = $(e.currentTarget);

    if (authModal) {
      authModal.destroy();
    }

    authModal = makeVueModal({
      trigger: $trigger[0],
      vue: {
        importComponent: async () => await import('@/vue/modals/auth'),
        props: {
          graphqlUrl: $trigger.data('graphql_url'),
          confirmationUrl: $trigger.data('confirmation_url'),
          confirmationType: $trigger.data('confirmation_type'),
          resendCodeInterval: $trigger.data('resend_code_interval'),
          nextUrl: $trigger.data('next_url'),
          isSignInTab: true,
          privacyUrl: $trigger.data('privacy_url')
        }
      },
      isModalCloseHandler: true
      // onShow: () => {
      //   const { trackEventLocation } = $(currentTarget).data();
      //   track({ event: 'callback_form_opened', data: trackEventLocation });
      // }
    });
    authModal.show();
  });
});
